const initPopups = () => {
	if ($('.js-popup')) {
		$('body').on('click', '.js-open-popup', function (e) {
			e.preventDefault();

			const popupId = $(this).data('popup-id');
			if (popupId) {
				closeNav();
				$(`.js-popup[data-popup-id=${popupId}]`).addClass('is-active');
				$('body').addClass('overflow-hidden');

				if (popupId.indexOf('video') !== -1) {
					if ($(`.js-popup[data-popup-id=${popupId}] video`).length) {
						console.log('autoplay start');
						$(`.js-popup[data-popup-id=${popupId}] video`).get(0).play();
					}
				}
			}
		});

		// Trigger popups that appear on page-load
		$('.js-popup').each(function () {
			const popup = $(this);

			// Open popups on page load
			// For popups with data-trigger-on-load attr
			const popupDelay = popup.attr('data-trigger-on-load');
			if (popupDelay && popupDelay != '') {
				const popupId = popup.data('popup-id');
				const popupFrequency = popup.data('popup-frequency');

				let triggerPopup = false;
				if (popupFrequency == 'always') {
					triggerPopup = true;
				} else if (
					popupFrequency == 'once' &&
					localStorage.getItem(`popup-${popupId}`) !== 'opened'
				) {
					triggerPopup = true;
				}

				if (triggerPopup) {
					setTimeout(() => {
						closeNav();
						popup.addClass('is-active');
						$('body').addClass('overflow-hidden');

						if (popupFrequency == 'once') {
							localStorage.setItem(`popup-${popupId}`, 'opened');
						}
					}, popupDelay);
				}
			}
		});

		$('.js-close-popup').on('click', function (e) {
			e.preventDefault();
			closePopups();
		});

		$(document).on('keyup', function (e) {
			if (e.key === 'Escape') {
				closePopups();
			}
		});
	}
};
